module.exports = __webpack_public_path__ + "black_wall.1a7f9d3dc5b7884eec5d.png";


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/assets/img/black_wall.png
// module id = ../../../../../client/assets/img/black_wall.png
// module chunks = styles